import api from '../api'

export default {


  getDailyClockings : async () => {
    return api.get('api/clockings/daily')
  },

  create : async (clocking) => {
    return api.post('api/clockings',clocking)
  },

  export : async (clockings) => {
    return api.get(`api/clockings/export?branch_id=${clockings.branch_id}&from=${clockings.from}&to=${clockings.to}&report_type=${clockings.report_type}`,{
      responseType: 'blob'
    })
  },

  exportGetData : async () => {
    return api.get('api/clockings/export-get-data')
  },

}
